import { Injectable } from '@angular/core';
import {
  NoticeOfPrivacyPracticesApi,
  UpdateNoticeOfPrivacyPracticesRequest,
} from '@models';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { NoticeOfPrivacyPracticesService } from './notice-of-privacy-practices.interface';

@Injectable({
  providedIn: 'root',
})
export class NoticeOfPrivacyPracticesApiService
  extends HttpService<NoticeOfPrivacyPracticesApi>
  implements NoticeOfPrivacyPracticesService
{
  protected override readonly collectionPath =
    '/compliance/notice-of-privacy-practices';

  getNotice(): Observable<NoticeOfPrivacyPracticesApi> {
    return this.http.get<NoticeOfPrivacyPracticesApi>(this.apiUrl);
  }

  saveDraft(
    body: UpdateNoticeOfPrivacyPracticesRequest
  ): Observable<NoticeOfPrivacyPracticesApi> {
    return this.http.put<NoticeOfPrivacyPracticesApi>(this.apiUrl, body);
  }

  publish(): Observable<NoticeOfPrivacyPracticesApi> {
    return this.http.post<NoticeOfPrivacyPracticesApi>(
      `${this.apiUrl}/publish`,
      {}
    );
  }
}
